import * as React from "react";
import RootCauseAnalysis from "../RootCauseAnalysis/RootCauseAnalysis";

const RootCauseAnalysisRoute: React.FC = () => {
    return (
        <div>
            <RootCauseAnalysis />
        </div>
    );
};

export default RootCauseAnalysisRoute;

